<template>
  <!-- 跟车员选择器 -->
  <van-action-sheet
    v-model="showCarFollowerPicker"
    @click-overlay="clickCarFollowerPickerBtn(false)"
    :round="false"
  >
    <div class="Line-car-follower-picker">
      <div class="car-follower-picker-title">
        <div @click="clickCarFollowerPickerBtn(false)">取消</div>
        <div>选择跟车员</div>
        <div @click="clickCarFollowerPickerBtn(true)">确认</div>
      </div>
      <div class="car-follower-picker-content" v-if="CarFollowerList.length">
        <div
          :class="[
            'car-follower-item',
            { active: handlerSelectActive(item.GID) },
          ]"
          v-for="(item, index) in CarFollowerList"
          :key="index"
          @click="clickCarFollowerTtem(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-else class="car-follower-picker-null">暂无数据</div>
    </div>
  </van-action-sheet>
</template>

<script>
import store from "@/store.js";
export default {
  data() {
    return {
      showCarFollowerPicker: false, // 显示跟车员列表
      CarFollowerList: [], // 跟车员查询集合
      CarFollowerSelectList: [], //选择的跟车员
    };
  },
  computed: {
    handlerSelectActive() {
      return (item) => {
        return this.CarFollowerSelectList.some((i) => i.GID == item);
      };
    },
  },
  methods: {
    handlerTransport(data) {
      this.$emit("handlerCarFollowerPicker", data);
    },

    // 点击跟车员选择器按钮
    clickCarFollowerPickerBtn(data) {
      this.showCarFollowerPicker = false; // 显示跟车员列表
      if (data) {
        this.handlerTransport(this.CarFollowerSelectList);
      }
    },

    // 点击选择跟车人
    clickCarFollowerTtem(data) {
      let list = this.CarFollowerSelectList;
      const idx = list.findIndex((c) => c.GID == data.GID);
      if (idx < 0) {
        this.CarFollowerSelectList.push(data);
      } else {
        this.CarFollowerSelectList.splice(idx, 1);
      }
    },

    // 请求
    init(list, value) {
      this.CarFollowerSelectList = JSON.parse(JSON.stringify(list));
      let CompInfo = store.getters.getCompInfo;
      let params = {
        IsCarFollower: true,
        CompGID: CompInfo.CompGID,
      };
      this.$http
        .post(
          this.$api.getCompanyDriverSimplifyQuery,
          this.$qs.stringify(params)
        )
        .then((res) => {
          if (res.success) {
            let list = res.data;
            let temp = [];
            list.forEach((item) => {
              temp.push({
                name: item.DriverName,
                GID: item.DriverGID,
                tel: item.DriverTel,
              });
            });
            // 输入框输入搜索内容
            if (value) {
              this.CarFollowerList = temp.filter((item) => {
                return item.name.includes(value);
              });
            } else {
              this.CarFollowerList = temp;
            }
          }
          this.showCarFollowerPicker = true;
          this.handlerTransport("");
        })
        .catch((err) => {
          console.log("err", err);
          this.showCarFollowerPicker = true;
        });
    },
  },
};
</script>

<style lang="less" scoped>
// 跟车员
.Line-car-follower-picker {
  background-color: #fff;
  max-height: 12rem;
  min-height: 3rem;
  display: flex;
  flex-direction: column;

  .car-follower-picker-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem;
    font-size: 0.38rem;
    color: #969799;
    border-bottom: 1px solid #f5f6f8;
    box-sizing: border-box;

    & > :nth-child(2) {
      font-size: 0.48rem;
      color: #323233;
      font-weight: 700;
    }
    & > :nth-child(3) {
      color: #576bb0;
    }
  }

  .car-follower-picker-content {
    flex: 1;
    color: #323233;
    padding: 0.3rem 0.4rem;
    height: 100%;
    overflow-y: auto;

    .car-follower-item {
      width: 100%;
      font-size: 0.46rem;
      padding: 0.3rem 0;
      border-bottom: 1px solid #f5f6f8;
    }
    .active {
      background-color: #f2f3f5;
      border-bottom: 1px solid #fff;
    }
  }
  .car-follower-picker-null {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.38rem;
  }
}
</style>
